import useResource from 'app/hooks/useResource';

import {
  getUploads,
  setUploadParams
} from 'app/actions/uploads';

import {
  uploads as resource
} from 'app/resources';

const useUploads = () => {
  return useResource({
    resource,
    getResource: getUploads,
    setResourceParams: setUploadParams
  });
}

export default useUploads;
